<template>
  <div class="card-header">
    <h5>Personal Details</h5>
  </div>
  <div class="card-body pt-0 mt-0">
    <p class="text-muted mb-2"><i class="fa fa-user"></i>&nbsp;&nbsp;{{ name }}</p>
    <p class="text-muted mb-2">
      <i v-if="signedInWithGoogle" class="text-bold">G</i>
      <i v-else class="text-bold fa fa-envelope"></i>&nbsp;&nbsp;{{ emailAddress }}
    </p>
    <p class="text-muted mb-2">
      <FontAwesomeIcon icon="fa-solid fa-location-dot" />&nbsp; &nbsp;{{ location }}
    </p>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapState } from "vuex";

export default {
  name: "PersonalDetails",
  components: {
    FontAwesomeIcon
  },
  computed: {
    ...mapState("user", ["user"]),
    name() {
      return this.user ? this.user.name : 'Unknown username';
    },
    signedInWithGoogle() {
      return this.user && this.user.idTokenClaims && this.user.idTokenClaims.idp === "google.com";
    },
    emailAddress() {
      return this.user && this.user.idTokenClaims && this.user.idTokenClaims.emails && this.user.idTokenClaims.emails.length > 0 
        ? this.user.idTokenClaims.emails[0] 
        : this.signedInWithGoogle ? 'Signed in with Google' : '';
    },
    location() {
      return this.user && this.user.idTokenClaims && this.user.idTokenClaims.country 
        ? this.user.idTokenClaims.country 
        : 'Unknown Country';
    }
  }
};
</script> 